import InAppMessage from "./in-app-message.js";
import { DOMUtils as de } from "../../util/dom-utils.js";
export default class SlideUpMessage extends InAppMessage {
  constructor(
    e,
    t,
    s,
    o,
    i,
    r,
    n,
    d,
    a,
    u,
    p,
    m,
    c,
    l,
    v,
    x,
    f,
    h,
    g,
    I,
    M,
    b,
    j,
    z,
  ) {
    (x = x || InAppMessage.th.Sh),
      (v = v || InAppMessage.th.Rh),
      super(
        e,
        (t = t || InAppMessage.TextAlignment.START),
        s,
        o,
        i,
        r,
        n,
        d,
        a,
        u,
        p,
        m,
        void 0,
        c,
        l,
        v,
        x,
        f,
        h,
        g,
        void 0,
        void 0,
        void 0,
        void 0,
        void 0,
        void 0,
        void 0,
        I,
        M,
        b,
        j,
        z,
      ),
      (this.zo = InAppMessage.TextAlignment.START);
  }
  vo() {
    return !1;
  }
  To() {
    const e = document.createElement("span");
    return e.appendChild(document.createTextNode(this.message || "")), e;
  }
  Ah(e) {
    const t = e.getElementsByClassName("ab-in-app-message")[0];
    de.Oo(t, !0, !0) ||
      (this.slideFrom === InAppMessage.SlideFrom.TOP
        ? (t.style.top = "0px")
        : (t.style.bottom = "0px")),
      super.Ah(e);
  }
  bt() {
    return super.bt(SlideUpMessage.rs);
  }
  static Xr(e) {
    return new SlideUpMessage(
      e[InAppMessage.hs.Vr],
      e[InAppMessage.hs.Wr],
      e[InAppMessage.hs.Nh],
      e[InAppMessage.hs.bs],
      e[InAppMessage.hs.Yr],
      e[InAppMessage.hs.Zr],
      e[InAppMessage.hs.URI],
      e[InAppMessage.hs.ra],
      e[InAppMessage.hs.sa],
      e[InAppMessage.hs.ta],
      e[InAppMessage.hs.ia],
      e[InAppMessage.hs.ds],
      e[InAppMessage.hs.pa],
      e[InAppMessage.hs.ma],
      e[InAppMessage.hs.na],
      e[InAppMessage.hs.ua],
      e[InAppMessage.hs.ca],
      e[InAppMessage.hs.fa],
      e[InAppMessage.hs.da],
      e[InAppMessage.hs.wa],
      e[InAppMessage.hs.CSS],
      e[InAppMessage.hs.ya],
      e[InAppMessage.hs.LANGUAGE],
      e[InAppMessage.hs.qs],
    );
  }
}
SlideUpMessage.rs = InAppMessage.ho.Kr;
